import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { WHATS_NEW_ENDPOINTS } from 'src/app/core/api/endpoints/whats-new.endpoints';

@Injectable({
  providedIn: 'root',
})
export class WhatsNewService {
  private api = inject(ApiService);
  private updatedWhatsNewList = new BehaviorSubject(false);
  newWhatsNewList = this.updatedWhatsNewList.asObservable();

  getWhatsNewList(params): Observable<any> {
    return this.api.get(WHATS_NEW_ENDPOINTS.V1.LIST, params).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  updateWhatsNewList(data) {
    this.updatedWhatsNewList.next(data);
  }

  deleteWhatsNew(ids: any[]): Observable<any> {
    return this.api
      .post(WHATS_NEW_ENDPOINTS.V1.SOFT_DELETE, {
        ids: ids,
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  getWhatsNewById(id): Observable<any> {
    return this.api.get(WHATS_NEW_ENDPOINTS.V1.RETRIEVE(id)).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  getUserTypes(): Observable<any> {
    return this.api.get(WHATS_NEW_ENDPOINTS.V1.USER_TYPES).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  updateWhatsNew(id, data): Observable<any> {
    return this.api.put(WHATS_NEW_ENDPOINTS.V1.UPDATE(id), data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError),
    );
  }

  createWhatsNew(data): Observable<any> {
    return this.api.post(WHATS_NEW_ENDPOINTS.V1.CREATE, data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError),
    );
  }

  getWhatsNewModalList(params): Observable<any> {
    return this.api.get(WHATS_NEW_ENDPOINTS.V1.PUBLISHED_LIST + params).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  toggleReadItem(id): Observable<any> {
    return this.api.get(WHATS_NEW_ENDPOINTS.V1.TOGGLE_READ(id)).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  toggleReadAllItem(): Observable<any> {
    return this.api.get(WHATS_NEW_ENDPOINTS.V1.READ_ALL).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  handleError(error) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
